module.exports = require("progress-bar-webpack-plugin");


//////////////////
// WEBPACK FOOTER
// external "progress-bar-webpack-plugin"
// module id = 46
// module chunks = 0